import { render, staticRenderFns } from "./RiskComment.vue?vue&type=template&id=6e330d9e&scoped=true&"
import script from "./RiskComment.vue?vue&type=script&lang=js&"
export * from "./RiskComment.vue?vue&type=script&lang=js&"
import style0 from "./RiskComment.vue?vue&type=style&index=0&id=6e330d9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e330d9e",
  null
  
)

export default component.exports